import Component from 'vue-class-component';
import moduleStore from './store/searchSpeaker';
import Vue from 'vue';
import PageState from './store/state';
import infiniteScroll from '@/components/infinite-scroll';
import SpeakerCards from './components/speakerCards/speakerCards';
import SearchByname from './components/searchByname/searchByname';
import { getQueryString } from '@/utils/location';
@Component({
  name: 'searchSpeaker',
  components: {
    SpeakerCards,
    SearchByname,
  },
  directives: { infiniteScroll },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    templateSpeaker:{
        type:String
    }
  },
  watch: {
    visible: {
      handler(newVal) {
        this.show = newVal;
        if (newVal) {
            //重新获取我的声音数据
            this.getCloneListFn();
        }
      },
    },
    currSelectIndex:{
        handler(newVal){
            this.showFilterTags= newVal!= null
        }
    }
  },
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class searchSpeakerPage extends Vue implements IvuePage<PageState> {
//   @Prop({ default: '' })
//   pageSource = '';
  state = new PageState();
  self: Vue = this;
  show = false; //当前页面显示/隐藏
  keyWord = '';
  allTagsList = [];
  speakerResults = []; //根据条件筛选出来的发音人
  pageSize = 16;
  pageNum = 1;
  totalPages = 1;
  totalElements = 0; //所有发音人个数

  morePull = require('/public/images/sameStyle/more_pull.png');
  morePullRed = require('/public/images/sameStyle/more_pull_red.png');
  moreUp = require('/public/images/sameStyle/more_up.png');
  selectTypeInfo = {
    //所有选择的查询条件value
    domainId: '',
    specificLanguage: '',
    gender: '',
    favourite: '',
  };
  selectTypeInfoTxt = {
    //所有选择的查询条件name
    domainId: '',
    specificLanguage: '',
    gender: '',
    favourite: '',
  };
  currSelectIndex = null; //当前展开的选择条件下标
  currentClickIndx = null;
  isAudioListing = false; //是否在试听发音人
  showSearchByName = false;
  currSpeaker = null; //当前选择的发音人
  selectSpeakerName = null; //当前选择的发音人(本体)
  allSpeakersMap = null; //处理后的发音人
  emotionListMap = null; //所有风格
  showFilterTags = false; //是否显示筛选标签
  myCloneList = [];//我的声音列表
  isLoading = false;//发音人数据查询中
  
  isTT = false;
  //筛选条件不为空 显示重置按钮(重置会包含克隆声音)
  get showReset(){
    let isEmpity =  Object.values(this.selectTypeInfo).every(value => value === '');
    return !isEmpity;
  }
  async mounted() {
    this.isTT =localStorage.getItem('platform') == 'tt';
    let selectSpeakerName = getQueryString('selectSpeakerName');
    this.selectSpeakerName = selectSpeakerName; //根据传入的默认发音人Id查找当前发音人
    this.getStoreSearchCriteriaFn();
    this.getSpeakerBySearchFn();
    this.getCloneListFn();
  }
  getCloneListFn(){
    this.$http('getCloneList',{status:"FINISHED"}).then(res=>{
      if(res.code == 200){
        this.myCloneList = res.data||[];
      }else{
        console.log('获取我的克隆声音失败')
      }
    })
  }
  /**获取全部分类 */
  getStoreSearchCriteriaFn() {
    let allTagsList = []; //所有筛选条件
    //语言 //性别 //收藏
    this.$http('getStoreSearchCriteria').then(res => {
      if (res.code == 200) {
        let tagsData = res.data;
        if (tagsData) {
          let tagKeyList = Object.keys(tagsData);
          tagKeyList.forEach(val => {
            let [value, key] = val.split(':');
            value = value.substr(2);
            tagsData[val] = tagsData[val].map(item => {
              item.key = key;
              return item;
            });
            let obj: any = {};
            obj.name = value;
            obj.key = key;
            tagsData[val].unshift({ name: '全部', value: '', key });
            if (tagsData[val].length > 12) {
              obj.type = 'more';
              obj.moreCount = tagsData[val].length - 11;
            }
            obj.data = tagsData[val];
            allTagsList.push(obj);
          });
        }
        this.allTagsList = [allTagsList[1], allTagsList[2], allTagsList[4]]; //todo
        // //追加一个收藏 -第一版先注释
        // let collectObj = {
        //   name: '收藏',
        //   key: 'favourite',
        //   data: [
        //     { key: 'favourite', name: '全部', value: '' },
        //     { key: 'favourite', name: '收藏', value: 'true' },
        //     { key: 'favourite', name: '未收藏', value: 'false' },
        //   ],
        // };
        // this.allTagsList.push(collectObj);
      } else {
        console.log('---获取发音人失败');
      }
    });
  }
  /**根据条件查询发音人信息*/
  getSpeakerBySearchFn(isLoadMore = false) {
    let queryParam: any = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        isGetPackage: false,
        // isGetPackage: true,
        ...this.selectTypeInfo,
      };
    if (!isLoadMore) {
      //更换了查询条件
      this.pageNum = 1;
    }
    if (this.totalPages>0 && this.pageNum > this.totalPages) {
      return;
    }
    this.isLoading = true;
    this.$http('getSpeakerBySearch', queryParam).then(res => {
      let { totalPages, results, totalElements } = res.data;
      this.totalPages = totalPages;
      this.totalElements = totalElements;
      //将风格中的第一个发音人作为默认发音人数据
      if (results.length > 0) {
        results = results.map((item, index) => {
          return {
            ...item,
            defaultSpeaker: item.speakerEmotionCacheVOList[0],
          };
        });
      }
      if (!isLoadMore) {
        this.speakerResults = results;
      } else {
        this.speakerResults = this.speakerResults.concat(results);
      }
      this.allSpeakersMap = this.speakerNormalize(this.speakerResults);
      this.isLoading = false;
    });
  }
  loadMore() {
    if (this.pageNum >= this.totalPages) {
      return;
    }
    this.pageNum++;
    this.getSpeakerBySearchFn(true);
  }
  selectType(e) {
    this.currSelectIndex = e;
    this.cancelListen();
  }
  chooseItem(e) {
    this.selectTypeInfo[e.key] = e.value;
    this.selectTypeInfoTxt[e.key] = e.name;
  }
  //重置类型选择里面的某个具体选择
  resetSubType() {
    this.selectTypeInfoTxt[this.allTagsList[this.currSelectIndex].key] = '';
    this.selectTypeInfo[this.allTagsList[this.currSelectIndex].key] = '';
  }
  subSubType() {
    //调用查询
    this.getSpeakerBySearchFn();
    this.currSelectIndex = null;
  }
  resetAllSelect() {
    this.selectTypeInfo = {
      //所有选择的查询条件value
      domainId: '',
      specificLanguage: '',
      gender: '',
      favourite: '',
    };
    this.selectTypeInfoTxt = {
      //所有选择的查询条件name
      domainId: '',
      specificLanguage: '',
      gender: '',
      favourite: '',
    };
    this.subSubType();
  }
  //显示根据发音人搜索
  toSearchByName() {
    this.cancelListen();
    //当前筛选标签是展开
    if(this.currSelectIndex){
      this.resetSubType();//重置当前筛选条件
      this.currSelectIndex = null;//关闭筛选标签
    }else{
      this.showFilterTags=false;//关闭筛选
    }
    this.showSearchByName = true;
  }
  //点击用TA配音
  useSpeaker() {
    this.cancelListen();
    //给当前发音人风格赋值
    let speaker = this.currSpeaker;
    if (!speaker) return;
    speaker.speakerEmotionCacheVOList &&
      speaker.speakerEmotionCacheVOList.forEach(item => {
        let moodName = item.speaker.split('@')[1];
        if (moodName) {
          if (this.$store.state.emotionListMap[moodName]) {
            item.moodImg = this.$store.state.emotionListMap[moodName].imageUrl;
          }
        } else {
          // item.moodImg = speaker.headerImage;//test -todo换成默认
          //使用默认头像
          item.moodImg = this.$store.state.emotionListMap['default2'].imageUrl;
        }
      });
    this.$store.state.currSpeaker = speaker;
    this.$emit('select-speaker', speaker);
    this.closeSpeakerPopup();
  }
  //取消试听
  cancelListen() {
    if (this.$refs.speakerCards) {
      let speakerCardsRef = this.$refs.speakerCards as any;
      speakerCardsRef.cancelListen();
    }
    if (this.$refs.searchByname) {
      let searchBynameRef = this.$refs.searchByname as any;
      searchBynameRef.byNameCancelListen();
    }
  }
  //记录当前点击的发音人:只有用TA配音时才保存到store
  setCurrentSpeaker(speaker) {
    this.currSpeaker = speaker;
  }
 // 发音人初始化
  speakerNormalize(targetArray = []) {
    let obj: any = {};
    // 发音人本体
    let defaultSpeakerIds = [];
    // 全体发音人
    let allSpeakerIds = [];
    // 发音人idMap
    let allSpeakerIdMap: any = {};
    let alLineSpeakerMap: any = {};
    // 发音人名字和英文名字的映射 包含“我的”
    let nameToEngNameMap = {};
    // 分类对象
    let typeSpeakerMap: any = {};
    for (let i = 0; i < targetArray.length; i++) {
      let speaker = targetArray[i];
      alLineSpeakerMap[speaker.speaker] = speaker;
      // 如果list中已经存在，即跳过
      if (allSpeakerIds.indexOf(speaker.speaker) > -1 || speaker.speaker.indexOf('48k') !== -1)
        continue;
      allSpeakerIds.push(speaker.speaker);
      allSpeakerIdMap[speaker.id] = speaker.speaker;

      let speakerMoods = speaker.speaker.split('@');
      let defaultSpeaker = speakerMoods[0];
      let speakerMood = speakerMoods[1] || 'default';
      // 只考虑本体
      if (speakerMoods.length == 1) {
        // 只做24k的映射
        if (!speaker.speaker.includes('48k')) {
          nameToEngNameMap[`${speaker.name}~${speaker.pinyin}～${speaker.pinyinInitial}`] =
            speaker.speaker;
        }
        // 分类归属
        if (Array.isArray(speaker.speakerType)) {
          speaker.speakerType.forEach(type => {
            typeSpeakerMap[type.id] = typeSpeakerMap[type.id] || {};
            typeSpeakerMap[type.id][defaultSpeaker] = 1;
          });
        }

        // 搜集本体
        if (defaultSpeakerIds.indexOf(defaultSpeaker) == -1) {
          defaultSpeakerIds.push(defaultSpeaker);
        }
      }
      // 风格名称
      speaker.styleName = speaker.name.split('|')[1] || '通用';
      if (obj[`${defaultSpeaker.replace('lpcnet', 'meet')}`]) {
        defaultSpeaker = defaultSpeaker.replace('lpcnet', 'meet');
      } else if (obj[`${defaultSpeaker.replace('meet', 'lpcnet')}`]) {
        defaultSpeaker = defaultSpeaker.replace('meet', 'lpcnet');
      }
      // map构造
      obj[`${defaultSpeaker}`] = obj[`${defaultSpeaker}`] || {};
      let moodsObj = obj[`${defaultSpeaker}`] || {};
      moodsObj[speakerMood] = speaker;
      obj[`${defaultSpeaker}`] = moodsObj;
      alLineSpeakerMap[speaker.speaker] = speaker;
    }
    return {
      allSpeakersMap: obj, //{speaker.speaker:[各个风格的数据]}
    };
  }

  closeSpeakerPopup() {
    //结束试听
    this.cancelListen();
    this.$emit('close');
  }
  toClone(){
    //关闭当前声音搜索弹框 跳转到小程序克隆页
    this.closeSpeakerPopup();
    this.$navigateTo({
        url:'/superclone-package/pages/clone-protocol/clone-protocol?from=sameType'
    });
    // this.$navigateTo({
    //     url:'/superclone-package/pages/voice-listen-page/voice-listen-page?from=cloneSuccess&taskId=611e8a89-9dd1-4486-8e9c-890697e5d10d'
    // });
  }
//   clearKeyword(){
//     let  card2Ref = this.$refs.speakerCards2;
//     //若有试听,取消
//     card2Ref && (card2Ref as any).cancelListen();
//     this.$emit('hideSearchByName');
//   }
//   search(){
//     this.getSpeakerBySearchFn();
//   }
}
